import commonMixin from '../mixins/common'
import PersonalProfile from '../components/Personal/PersonalProfile'
import Return from '../components/Personal/Return'
import Account from '../components/Personal/Account'
import Depository from '../components/Depository'
import OrderPage from '../components/Order/OrderPage'
import Authorize from '../components/Auth/Authorize/AuthForm'
import AuthPopup from '../components/Auth/Popups/Popup'
import Register from '../components/Auth/Register/RegForm'
import Subscribe from '../components/Subscribe'

export default {
  name: 'app',
  mixins: [commonMixin],
  components: {
    PersonalProfile,
    Return,
    Account,
    Depository,
    OrderPage,
    Authorize,
    AuthPopup,
    Register,
    Subscribe
  },
  props: {
    application: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    getComponentName () {
      try {
        return this.application.config.component.name
      } catch (error) {
        return ''
      }
    },
    getComponentData () {
      try {
        return this.application.config.component.data
      } catch (error) {
        return {}
      }
    }
  },
  created: function () {
  } // Действия при создании
}



// WEBPACK FOOTER //
// ./src/app/script.js